import { Button, Text } from '@datanomik/core-ui';
import React from 'react';
import { t } from 'i18next';

import Modal from '@/views/common/Modal';

import { useWorkspaceContext } from '@/contexts/workspace';
import { useKeycloakContext } from '@/contexts/keycloak/context';
interface WorkspaceEmptyModalRawProps {
  className?: string;
}

const WorkspaceEmptyModalRaw = ({ className }: WorkspaceEmptyModalRawProps) => {
  const { logoutKeycloak } = useKeycloakContext();
  const { workspace: { handleCloseEmptyWorkspace, openEmptyWorkspace } } = useWorkspaceContext();

  const handleRedirect = () => {
    handleCloseEmptyWorkspace();
    logoutKeycloak();
  };

  return (
    <Modal
      openModal={openEmptyWorkspace}
      backdropClose={false}
      title="Workspaces"
      DialogProps={{
        maxWidth: 'xs',
        PaperProps: {
          sx: { minWidth: '400px' },
        },
      }}
      DialogHeaderProps={{
        text: t('Workspaces'),
      }}
      DialogActionsProps={{
        dialogActions: (
          <Button onClick={handleRedirect} className="w-full">
            {t('Log out')}
          </Button>
        ),
      }}
    >
      <div className={className}>
        <Text variant="caption" tone="muted">
          {t('You do not have assigned workspaces')}
        </Text>
      </div>
    </Modal>
  );
};
export default WorkspaceEmptyModalRaw;
